module.exports = __webpack_public_path__ + "static/media/portfolio-4.e5ffe9ca.jpg";